import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import Tabs from "design/components/toolbar/Tabs";
import PeriodSelector from "components/PeriodSelector";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import SplitView from "design/layouts/SplitView";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import ToolbarTitle from "design/components/texts/ToolbarTitle";

const ToolbarWithHeading = (props: React.PropsWithChildren<{}>) => {
  return (
    <ToolbarContainer>
      <SplitView partCnt={2}>
        <ToolbarTitle>{props.children}</ToolbarTitle>
        <Right>
          <PeriodSelector level="Month" />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default ToolbarWithHeading;
